import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { AppStateModel } from '@libs/shared/models';
import { AppStateStore } from './app-state.store';

@Injectable({ providedIn: 'platform' })
export class AppStateQuery extends Query<AppStateModel> {
  public constructor(protected override store: AppStateStore) {
    super(store);
  }
}
